<template>
  <n-modal
    v-model:show="showModal"
    style="width: 600px"
    class="custom-card"
    preset="card"
    :title="t('modules.resistance.external.modal.title')"
    :bordered="false"
    size="huge"
  >
    <div v-if="text === ResistanceModalText.ENTER">
      {{ t('modules.resistance.external.modal.enter') }}
      <strong>{{ t('modules.resistance.external.modal.enterWarning') }}</strong>
    </div>
    <div v-if="text === ResistanceModalText.LEAVE">
      {{ t('modules.resistance.external.modal.leave') }}
      <strong>{{ t('modules.resistance.external.modal.leaveWarning') }}</strong>
    </div>
    <div class="resistance-external__close">
      <BfButton @click="close">
        {{ t('common.continue') }}
      </BfButton>
    </div>
  </n-modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { NModal } from 'naive-ui'
import { BfButton } from '@finetic/bikefitting-ui'
import { ResistanceModalText } from '@/types/resistance'

const { t } = useI18n()
const emit = defineEmits(['close'])

withDefaults(
  defineProps<{
    text: ResistanceModalText
  }>(),
  {
    text: ResistanceModalText.ENTER,
  },
)

const showModal = computed({
  get() {
    return true
  },
  set() {
    close()
    return false
  },
})

const close = () => {
  emit('close')
}
</script>

<style lang="scss">
.resistance-external {
  &__close {
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
  }
}
</style>
